import * as React from 'react';
import Svg, {
  Defs, ClipPath, Path, G,
} from 'react-native-svg';
import Colors from 'theme/colors';

function TradeWalk(props: any) {
  const { fillColor = Colors.ICON_SECONDARY } = props;
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1080 1080"
      {...props}
    >
      <Defs>
        <ClipPath id="prefix__a">
          <Path d="M0 0h1080v1080H0z" />
        </ClipPath>
      </Defs>
      <G data-name="Custom Size \u2013 3" clipPath="url(#prefix__a)">

        <G data-name="Group 1984">
          <Path
            data-name="Path 577"
            d="M310.646 742.771h25.788a27.971 27.971 0 0020.425-8.216 27.4 27.4 0 008.33-20.311V659.7l-83.525-41.079v95.624a27.4 27.4 0 008.33 20.311 28.249 28.249 0 0020.652 8.215zm432.919 0h25.788a28.356 28.356 0 0020.539-8.216 27.211 27.211 0 008.444-20.311v-95.623L714.81 659.7v54.544a27.4 27.4 0 008.33 20.311 27.971 27.971 0 0020.425 8.216zM540 682.522q27.614 0 57.966-.685t59.563-1.712q29.211-1.027 53.516-2.625t39.823-3.2q22.593-2.739 35.031-15.291t12.438-34v-37.426a171.346 171.346 0 00-2.738-32.521 106.365 106.365 0 00-8.672-26.245 146.487 146.487 0 00-15.975-25.218l-18.715-23.963q-3.88-19.4-9.471-38.341t-11.068-34q-5.477-15.062-9.129-23.278a71.718 71.718 0 00-25.446-29.668q-16.545-10.959-38.453-14.154-7.759-.913-24.989-1.6t-41.307-1.025q-24.076-.342-52.375-.342t-52.489.342q-24.191.342-41.306 1.027t-24.875 1.6q-21.908 2.736-38.453 13.919a73.333 73.333 0 00-25.446 29.9q-3.651 8.216-9.128 23.278t-11.068 34q-5.591 18.942-9.471 38.341l-18.714 23.964a146.483 146.483 0 00-15.975 25.218 106.354 106.354 0 00-8.672 26.245 171.345 171.345 0 00-2.739 32.521v37.423q0 21.452 12.438 34t35.031 15.3q15.518 1.6 39.823 3.2t53.516 2.625q29.211 1.027 59.563 1.712t57.966.679zm-157.01-59.565q-15.29 0-25.446-10.156t-10.155-25.218q0-15.062 10.155-25.218t25.446-10.159q15.062 0 25.217 10.156t10.155 25.218q0 15.062-10.155 25.218t-25.217 10.159zm99.272-8.672q-11.411 0-18.485-7.075t-7.075-18.486q0-11.411 7.075-18.486t18.485-7.075h115.475q11.411 0 18.485 7.075t7.075 18.486q0 11.411-7.075 18.486t-18.485 7.075zm214.748 8.672q-15.062 0-25.217-10.156t-10.155-25.218q0-15.062 10.155-25.218t25.217-10.159q15.29 0 25.446 10.156t10.154 25.221q0 15.062-10.155 25.218t-25.445 10.156zM373.861 460.694q2.51-11.411 6.39-23.849t7.987-23.278a167.346 167.346 0 017.3-17q4.564-7.988 10.27-11.867t15.062-5.021q12.1-1.826 40.736-2.739t78.391-.913q49.75 0 78.5.8t40.394 2.853q9.585 1.369 15.176 5.135t10.384 11.753a113.3 113.3 0 017.417 16.774q3.994 10.84 7.759 23.392t6.276 23.963q1.826 6.39-.913 9.357t-9.585 2.51q-17.344-.913-38.225-1.94t-49.401-1.718q-28.527-.685-67.779-.685-39.481 0-67.893.685t-49.297 1.715q-20.881 1.027-38.226 1.94-6.846.456-9.471-2.51t-1.252-9.357z"
            fill={fillColor}
          />
          <G data-name="Group 1981">
            <G data-name="Group 1980">
              <Path
                data-name="Path 588"
                d="M1041.644 148.983a42.186 42.186 0 00-45.842 38.184l-5.589 61.317C895.38 99.55 730.76 0 540.016 0c-205.2 0-386.031 117.117-475.8 292.9a42.186 42.186 0 1075.138 38.371c75.971-148.762 228.532-246.9 400.659-246.9 156.885 0 298.467 81.7 379.579 209.689l-60.149-42.96a42.187 42.187 0 00-49.037 68.66l182.4 130.277c26.734 19.058 63.607 1.612 66.53-30.5l20.484-224.712a42.184 42.184 0 00-38.176-45.842z"
                fill={fillColor}
              />
            </G>
          </G>
          <G data-name="Group 1983">
            <G data-name="Group 1982">
              <Path
                data-name="Path 589"
                d="M997.431 730.347a42.187 42.187 0 00-56.758 18.382c-75.972 148.761-228.532 246.9-400.659 246.9-156.885 0-298.467-81.7-379.579-209.689l60.152 42.962a42.187 42.187 0 0049.037-68.66L87.223 629.962c-26.407-18.867-63.577-1.942-66.53 30.5L.209 885.17a42.186 42.186 0 1084.022 7.662l5.59-61.318c94.831 148.936 259.451 248.487 450.194 248.487 205.2 0 386.031-117.117 475.8-292.9a42.187 42.187 0 00-18.384-56.754z"
                fill={fillColor}
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
}

export default TradeWalk;
